<template>
  <v-container :class="containerClass" fluid>
    <classroom-schedule-form
      mode="edit"
      :schedule="schedule.data"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            left
            :href="$route('classroom-schedules.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>
            Edit {{ schedule.data.classroom.name }} -
            {{ formatDate(schedule.data.class_date, 'D MMM YYYY') }}
          </h2>
        </div>
      </template>
    </classroom-schedule-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomScheduleForm from '@components/ClassroomSchedule/Form'
export default {
  components: {
    ClassroomScheduleForm,
  },
  layout: LayoutDashboard,
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('classroom-schedules.index')
    },
  },
}
</script>
